import React from "react";
import { HStack } from "@chakra-ui/react";
import HoneyIcon from "components/HoneyIcon";
import useTranslate from "hooks/useTranslate";
import WalletAsset from "components/WalletAsset";
import useAssets from "hooks/useAssets";
import useVesting from "hooks/useVesting";
import EtherAmount from "components/EtherAmount";
import { honeyUniswapUrl, vestingAppUrl } from "config";

const WalletAssetsContainer = () => {
  const translate = useTranslate();
  const { honeyBalance } = useAssets();

  const { vestingAmountRemaining } = useVesting();

  return (
    <HStack justify="stretch" spacing={3}>
      <WalletAsset
        title={translate("header:honey:title")}
        icon={HoneyIcon}
        value={<EtherAmount amount={honeyBalance} />}
        link={
          honeyUniswapUrl
            ? {
                href: honeyUniswapUrl,
                label: translate("common:buy"),
              }
            : undefined
        }
      />

      <WalletAsset
        title={translate("header:vested:title")}
        icon={HoneyIcon}
        value={<EtherAmount amount={vestingAmountRemaining} />}
        link={{
          href: vestingAppUrl!,
          label: translate("header:vesting:details"),
        }}
      />
    </HStack>
  );
};

export default WalletAssetsContainer;
